Ext.define('SA.HistogramView', {
    alias: 'widget.histogram-view',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-histogram-view',

    items: [
        {
            xtype: 'load-mask',
            itemId: 'mask'
        }, {
            xtype: 'mask-scroll-view',
            itemId: 'scrollView'
        }, {
            xtype: 'chart-legend',

            content: {
                edit: {xtype: 'histogram-legend-edit'},
                summary: {xtype: 'histogram-legend-summary'}
            }
        }
    ],

    initComponent() {
        this.callParent();

        this.mask = this.down('#mask');
        this.scrollView = this.down('#scrollView');
        this.legend = this.down('chart-legend');
    },

    initEvents() {
        this.callParent();

        this.legend.onEditContentEvent('flush:chartTitle', this.onChartTitleFieldFlush, this);
        this.legend.onEditContentEvent('change:attribute', this.onAttributeDropdownChange, this);
        this.legend.onEditContentEvent('change:binSize', this.onBinSizeControlChange, this);
        this.legend.onEditContentEvent('change:barColor', this.onBarColorButtonChange, this);
    },

    onAttributeDropdownChange(attribute) {
        this.fireEvent('change:attribute', attribute);
    },

    onBarColorButtonChange(barColor) {
        this.fireEvent('change:barColor', barColor);
    },

    onBinSizeControlChange(binSize) {
        this.fireEvent('change:binSize', binSize);
    },

    onChartTitleFieldFlush(chartTitle) {
        this.fireEvent('flush:chartTitle', chartTitle);
    },

    onResize() {
        this.callParent(arguments);

        this.scrollView.setMaxSize(this.getSize());
    },

    getContentForState(state) {
        var result = state.request.getResult();

        if (!result.hasData()) {
            return SA.HistogramNoDataView.get(result.getNoDataReason());
        }

        var modelState = state.model,
            availableSpace = state.availableSpace,
            data = result.getData(),
            chartParams = SA.HistogramChartParams.get({availableSpace, modelState, data});

        return SA.Histogram.build(chartParams);
    },

    setState(state) {
        if (state.firstResultPending) {
            return; 
        }
        else if (state.request.isPending()) {
            this.mask.hide();
            this.scrollView.showMask();
            this.legend.setState(state);
            return;
        }

        this.mask.hide();
        this.scrollView.hideMask();
        this.scrollView.setScrollContent(this.getContentForState(state));
        this.legend.setState(state);
    }
});